"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTimestampFilter = mapTimestampFilter;
const date_fns_1 = require("date-fns");
const utils_1 = require("./utils");
function mapTimestampFilter(filter) {
    if (filter.type !== 'DATE' && filter.type !== 'TIMESTAMP') {
        throw new Error(`Filter type ${filter.type} is not a date or timestamp, cannot map to date`);
    }
    // assert that the value is an object
    if (typeof filter.value !== 'object') {
        throw new Error(`Filter value is not an object, cannot map to date`);
    }
    switch (filter.operator) {
        case 'IS_IN_THE_LAST':
            return {
                range: {
                    [filter.field]: {
                        gte: `now-${filter.value.value}${(0, utils_1.mapTimeUnitToElasticsearchDateMath)(filter.value.unit)}/d`,
                        lte: 'now',
                    },
                },
            };
        case 'IS_EQUAL_TO':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.eq).toISOString(),
                        lte: (0, date_fns_1.endOfDay)(filter.value.eq).toISOString(),
                    },
                },
            };
        case 'IS_BETWEEN':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString(),
                        lte: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString(),
                    },
                },
            };
        case 'IS_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gt: (0, date_fns_1.startOfDay)(filter.value.gt).toISOString(),
                    },
                },
            };
        case 'IS_ON_OR_AFTER':
            return {
                range: {
                    [filter.field]: {
                        gte: (0, date_fns_1.startOfDay)(filter.value.gte).toISOString(),
                    },
                },
            };
        case 'IS_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lt: (0, date_fns_1.endOfDay)(filter.value.lt).toISOString(),
                    },
                },
            };
        case 'IS_ON_OR_BEFORE':
            return {
                range: {
                    [filter.field]: {
                        lte: (0, date_fns_1.endOfDay)(filter.value.lte).toISOString(),
                    },
                },
            };
        default:
            // @ts-expect-error -- ts is right this SHOULD be impossible if it's not you've added a new operator
            throw new Error(`Operator ${filter.operator} not implemented`);
    }
}
//# sourceMappingURL=map-timestamp-filter.js.map